
const ITETags = (doc, data, clinica, item, index) => {
    var ITE = doc.createElement("ITE");

    //Número de Linea
    var ITE_1 = doc.createElement("ITE_1");
    ITE_1.innerHTML = parseInt(index + 1);
    ITE.appendChild(ITE_1);

    //Campo Vacio pero Obligatorio por version UBL 2.1
    var ITE_2 = doc.createElement("ITE_2");
    ITE_2.innerHTML = " ";
    ITE.appendChild(ITE_2);

    //Cantidad del Producto o Servicio
    var ITE_3 = doc.createElement("ITE_3");
    ITE_3.innerHTML = item.cantidad;
    ITE.appendChild(ITE_3);

    //Unidad de Medida Requerida por la DIAN
    var ITE_4 = doc.createElement("ITE_4");
    ITE_4.innerHTML = item.um;
    ITE.appendChild(ITE_4);

    //Total de la Linea
    var ITE_5 = doc.createElement("ITE_5");
    ITE_5.innerHTML = item.costo_total;
    ITE.appendChild(ITE_5);

    //Moneda del Cobro de Producto
    var ITE_6 = doc.createElement("ITE_6");
    ITE_6.innerHTML = "COP";
    ITE.appendChild(ITE_6);

    //Valor Unitario
    var ITE_7 = doc.createElement("ITE_7");
    ITE_7.innerHTML = item.precio;
    ITE.appendChild(ITE_7);

    //Moneda del Valor o Servicio
    var ITE_8 = doc.createElement("ITE_8");
    ITE_8.innerHTML = "COP";
    ITE.appendChild(ITE_8);

    //Descripcion del Servicio o Producto en FACTURA
    var ITE_11 = doc.createElement("ITE_11");
    ITE_11.innerHTML = item.descripcion;
    ITE.appendChild(ITE_11);

    //Descripcion del Servicio o Producto en FACTURA y/o NOTA (Credito o Debito)
    var ITE_12 = doc.createElement("ITE_12");
    ITE_12.innerHTML = " ";
    ITE.appendChild(ITE_12);

    //Descripcion del Servicio o Producto en FACTURA y/o NOTA (Credito o Debito)
    var ITE_13 = doc.createElement("ITE_13");
    ITE_13.innerHTML = " ";
    ITE.appendChild(ITE_13);

    //Codigo del Producto (CUPS, CUMS, u otro Codigo dependiendo del Item)
    var ITE_17 = doc.createElement("ITE_17");
    ITE_17.innerHTML = item.codigo != null && item.codigo != undefined ? item.codigo : "01";
    ITE.appendChild(ITE_17);

    //Codigo Correspondiente del Vendedor al Articulo
    var ITE_18 = doc.createElement("ITE_18");
    ITE_18.innerHTML = "1" //QUEMADO
    ITE.appendChild(ITE_18);

    //Valor con Descuentos y Cargos aplicados
    var ITE_19 = doc.createElement("ITE_19");
    ITE_19.innerHTML = item.costo_total;
    ITE.appendChild(ITE_19);

    //Moneda con Descuentos Aplicados
    var ITE_20 = doc.createElement("ITE_20");
    ITE_20.innerHTML = item.costo_total;
    ITE.appendChild(ITE_20);

    //Valor a Pagar del Item
    var ITE_21 = doc.createElement("ITE_21");
    ITE_21.innerHTML = item.costo_total;
    ITE.appendChild(ITE_21);

    //Valor a Pagar del Item
    var ITE_22 = doc.createElement("ITE_22");
    ITE_22.innerHTML = "COP";
    ITE.appendChild(ITE_22);

    //Cantidad Real sobre la cual el precio aplica
    var ITE_27 = doc.createElement("ITE_27");
    ITE_27.innerHTML = item.cantidad;
    ITE.appendChild(ITE_27);

    //Unidad de Medida del Articulo Solicitado
    var ITE_28 = doc.createElement("ITE_28");
    ITE_28.innerHTML = item.um;
    ITE.appendChild(ITE_28);

    //ITE.appendChild(IPATags(doc, data, clinica, item, index)); //Servicio de Regalo
    ITE.appendChild(IAETags(doc, data, clinica, item, index));
    ITE.appendChild(ITSTags(doc, data, clinica, item, index));

    return ITE;
}

const IPATags = (doc, data, clinica, item, index) => {
    var IPA = doc.createElement("IPA");

    var IPA_1 = doc.createElement("IPA_1");
    IPA_1.innerHTML = item.codigo != null && item.codigo != undefined ? item.cup : " ";
    IPA.appendChild(IPA_1);

    var IPA_2 = doc.createElement("IPA_2");
    IPA_2.innerHTML = item.precio;
    IPA.appendChild(IPA_2);

    var IPA_3 = doc.createElement("IPA_3");
    IPA_3.innerHTML = 'COP';
    IPA.appendChild(IPA_3);

    return IPA
}

const IAETags = (doc, data, clinica, item, index) => {
    var IAE = doc.createElement("IAE");

    var IAE_1 = doc.createElement("IAE_1");
    IAE_1.innerHTML = item.codigo != null && item.codigo != undefined ? item.codigo : " ";
    IAE.appendChild(IAE_1);

    var IAE_2 = doc.createElement("IAE_2");
    IAE_2.innerHTML = 999;
    IAE.appendChild(IAE_2);

    return IAE;
}

const ITSTags = (doc, data, clinica, item, index) => {
    let ITS = doc.createElement("ITS");

    let ITS_1 = doc.createElement("ITS_1");
    ITS_1.innerHTML = clinica.nit.split("-")[0];
    ITS.appendChild(ITS_1);

    let ITS_2 = doc.createElement("ITS_2");
    ITS_2.innerHTML = item.codigo_autorizacion != null && item.codigo_autorizacion != undefined ? item.codigo_autorizacion : " ";
    ITS.appendChild(ITS_2);

    let ITS_3 = doc.createElement("ITS_3");
    ITS_3.innerHTML = clinica.cod_act_econ;
    ITS.appendChild(ITS_3);

    return ITS;
}

export default ITETags;